import { DataCard, DataCardRow } from "../DataCard/DataCard";

interface Props {
  data: {
    entryStrategy: {
      shortDescription: string;
      entryPricePoints: {
        firstEntry: number;
        secondEntry: number;
        thirdEntry: number;
      };
    };
    positionSizing: {
      shortDescription: string;
      positionSizingData: {
        percentOfCryptoPortfolio: number;
        percentOfReserveForPotentialDips: number;
      };
    };
    riskManagement: {
      shortDescription: string;
      stopLossAndTakeProfitLevels: {
        firstStopLoss: number;
        firstTakeProfit: number;
        secondTakeProfit: number;
      };
    };
  };
}

export const EntryStrategy = ({ data }: Props) => {
  const formatPercentage = (value) => {
    return (
      <>
        {value > 0 && "+"}
        {value.toFixed(2)}
      </>
    );
  };
  if (!data) return <></>;
  return (
    <div className="flex gap-2 sm:gap-5 flex-col sm:flex-row">
      <DataCard
        title="Entry Strategy"
        subtitle={data.entryStrategy.shortDescription}
        premium
      >
        <DataCardRow
          title="Initial entry at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.entryStrategy.entryPricePoints.firstEntry} USD
            </p>
          }
        />

        <DataCardRow
          title="Secondary entry at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.entryStrategy.entryPricePoints.secondEntry} USD
              <span className="text-xs opacity-50">
                {formatPercentage(
                  (100 *
                    (data.entryStrategy.entryPricePoints.secondEntry -
                      data.entryStrategy.entryPricePoints.firstEntry)) /
                    data.entryStrategy.entryPricePoints.firstEntry,
                )}
                % from initial
              </span>
            </p>
          }
        />
        <DataCardRow
          title="Final entry at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.entryStrategy.entryPricePoints.thirdEntry} USD
              <span className="text-xs opacity-50">
                {formatPercentage(
                  (100 *
                    (data.entryStrategy.entryPricePoints.thirdEntry -
                      data.entryStrategy.entryPricePoints.firstEntry)) /
                    data.entryStrategy.entryPricePoints.firstEntry,
                )}
                % from initial
              </span>
            </p>
          }
        />
      </DataCard>

      <DataCard
        title="Position Sizing"
        premium
        subtitle={data.positionSizing.shortDescription}
      >
        <DataCardRow
          title="% of crypto portfolio"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.positionSizing.positionSizingData.percentOfCryptoPortfolio}%{" "}
              <span className="text-xs opacity-50">maximum</span>
            </p>
          }
        />
        <DataCardRow
          title="Reserve"
          valueElement={
            <p className="font-medium flex gap-1">
              {
                data.positionSizing.positionSizingData
                  .percentOfReserveForPotentialDips
              }
              %<span className="text-xs opacity-50">for potential dips</span>
            </p>
          }
        />
      </DataCard>

      <DataCard
        title="Risk Management"
        premium
        subtitle={data.riskManagement.shortDescription}
      >
        <DataCardRow
          title="Set stop-loss at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.riskManagement.stopLossAndTakeProfitLevels.firstStopLoss}{" "}
              USD{" "}
              <span className="text-xs opacity-50">
                {formatPercentage(
                  (100 *
                    (data.riskManagement.stopLossAndTakeProfitLevels
                      .firstStopLoss -
                      data.entryStrategy.entryPricePoints.firstEntry)) /
                    data.entryStrategy.entryPricePoints.firstEntry,
                )}
                % from entry
              </span>
            </p>
          }
        />

        <DataCardRow
          title="Initial profit taking at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.riskManagement.stopLossAndTakeProfitLevels.firstTakeProfit}{" "}
              USD
              <span className="text-xs opacity-50">
                {formatPercentage(
                  (100 *
                    (data.riskManagement.stopLossAndTakeProfitLevels
                      .firstTakeProfit -
                      data.entryStrategy.entryPricePoints.firstEntry)) /
                    data.entryStrategy.entryPricePoints.firstEntry,
                )}
                % from entry
              </span>
            </p>
          }
        />
        <DataCardRow
          title="Secondary profit taking at"
          valueElement={
            <p className="font-medium flex gap-1">
              {data.riskManagement.stopLossAndTakeProfitLevels.secondTakeProfit}{" "}
              USD
              <span className="text-xs opacity-50">
                {formatPercentage(
                  (100 *
                    (data.riskManagement.stopLossAndTakeProfitLevels
                      .secondTakeProfit -
                      data.entryStrategy.entryPricePoints.firstEntry)) /
                    data.entryStrategy.entryPricePoints.firstEntry,
                )}
                % from entry
              </span>
            </p>
          }
        />
      </DataCard>
    </div>
  );
};
